<template>
  <section class="mt-8" v-if="modelValue">
    <h3 v-if="title" class="mb-4 text-lg">{{ title }}</h3>
    <div class="mb-12 flex flex-col gap-4">
      <SelectedUsagesInput
        v-model="usageItems"
        :country="modelValue.country"
        :allowedUsageTypes="allowedUsageTypes"
        :usageSet="usageItemsKey === 'landscapeUsageItems' ? 'landscape' : 'standard'"
        @reorder="emit('usagesReordered', $event)" />
      <UsagesInput v-model="usageItems" :country="modelValue.country" :allowedUsageTypes="allowedUsageTypes" />
    </div>
    <ErrorMessage v-if="showUsageItemsError" :name="usageItemsKey" class="pt-5 error-message" />
  </section>
</template>

<script lang="ts" setup generic="T extends { usageItems: SharedUsageItem[]; country?: string }">
import { computed, type PropType } from 'vue'
import type { SharedUsageItem } from '@/schemas/general/types'
import UsagesInput from '@/components/partials/inputs/UsagesInput.vue'
import SelectedUsagesInput from '@/components/partials/inputs/SelectedUsagesInput.vue'
import ErrorMessage from '@/components/shared/ErrorMessage.vue'
const props = withDefaults(
  defineProps<{
    showUsageItemsError?: boolean
    title?: string
    usageItemsKey?: string
    allowedUsageTypes?: readonly string[]
  }>(),
  {
    showUsageItemsError: false,
    title: '',
    usageItemsKey: 'usageItems',
    allowedUsageTypes: undefined,
  }
)
const emit = defineEmits<{
  (e: 'usagesReordered', payload: { fromIndex: number; toIndex: number }): void
}>()
const modelValue = defineModel({ type: Object as PropType<T> })
const usageItems = computed({
  get: () =>
    ((modelValue.value as Record<string, unknown> | undefined)?.[props.usageItemsKey] ?? []) as SharedUsageItem[],
  set: (value: SharedUsageItem[]) => {
    if (!modelValue.value) return
    modelValue.value = {
      ...modelValue.value,
      [props.usageItemsKey]: value,
    }
  },
})
</script>
